<template>
  <div id="app" class="flex_g flex_column">
    <div id="headBar" v-if="show" :class="isfixTab ? 'isfixTab' : ''">
      <headBar ref="head" :pageUrl="toPath" :isChange="isChangeRoute"></headBar>
    </div>
    <div id="glHeadBar" v-if="glShow" :class="isfixTab ? 'isfixTab' : ''">
      <starryHeadBar ref="glHead" :pageUrl="toPath"></starryHeadBar>
    </div>
    <div class="appContainer" :style="isfixTab ? 'marginTop:5.36rem' : ''">
      <router-view v-if="isRouterAlive" />
    </div>
    <div v-if="show">
      <footBar></footBar>
    </div>
    <div v-if="footerShow">
      <starryFootBar></starryFootBar>
    </div>
  </div>
</template>
<script>
import headBar from "./components/headBar";
import footBar from "./components/footBar";
import starryHeadBar from "./components/starryGLHeader.vue";
import starryFootBar from "./components/starryGLFoot.vue";
export default {
  name: "app",
  components: { headBar, footBar, starryHeadBar, starryFootBar },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      show: false,
      glShow: false,
      footerShow: false,
      isfixTab: false,
      toPath: "/index",
      isRouterAlive: true,
      isChangeRoute: false,
    };
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  watch: {
    $route(route) {
      // console.log(route);
      if (
        route.fullPath != "/login" &&
        route.fullPath.indexOf("/register") == -1 &&
        route.fullPath.indexOf("/resetPwd") == -1 &&
        route.fullPath != "/forgetPwd" &&
        route.fullPath.indexOf("/starryGl") == -1
        // route.fullPath != "/error"
      ) {
        console.log("Routed to: " + route.fullPath);
        this.show = true;
        sessionStorage.setItem("preLogin", route.fullPath);
        this.toPath = "/" + route.fullPath.split("/")[1];
        this.isChangeRoute = true;
        if (this.$refs.head) {
          this.$refs.head.changeroute();
        }
      } else {
        this.show = false;
      }

      if (
        route.fullPath.indexOf("/starryGl") > -1
      ) {
        this.toPath = route.fullPath;
        this.glShow = true;
        this.footerShow = true;
      } else {
        this.glShow = false;
        this.footerShow = false;
      }
    },
  },
  methods: {
    // 通过声明reload方法，控制router-view的显示或隐藏，从而控制页面的再次加载
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    handleScroll(e) {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollTop > 50) {
        this.isfixTab = true;
      } else {
        this.isfixTab = false;
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
}
.appContainer {
  flex: 1;
  // overflow: hidden;
  position: relative;
}
.isfixTab {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  animation: headShow 0.5s;
}
@keyframes headShow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
